// Shared inline pill for vendor PO status across admin PO List + PO Detail
// (Phase 1B §3.3). Palette lives in POStatusBadge.lib.ts (single source of
// truth for the 9-state POStatus color language).

import type { POStatus } from '../mocks/data/inventory/purchase-orders'
import { PO_STATUS_PALETTE } from './POStatusBadge.lib'

export function POStatusBadge({ status }: { status: POStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ${PO_STATUS_PALETTE[status]}`}
    >
      {status}
    </span>
  )
}
